import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { AppLink, routeNaming, AppRedirect } from '../../../routes';
import { SessionStore } from '../../../stores/SessionStore';
import styles from './MyAccountMenu.css';

const IPropTypes = {
  indexSelectedItem: PropTypes.number,
};

const defaultProps = {
  indexSelectedItem: null,
};

const menuItems = () => {
  const items = [{ name: 'Mis datos', routeName: routeNaming.MY_DATA },
    { name: 'Mis direcciones', routeName: routeNaming.MY_ADDRESSES },
    { name: 'Mis teléfonos', routeName: routeNaming.MY_PHONE_NUMBERS },
    { name: 'Mis datos de facturación', routeName: routeNaming.MY_BILLING_DATA },
    { name: 'Mis compras', routeName: routeNaming.MY_ORDERS },
    { name: 'Mis favoritos', routeName: routeNaming.MY_FAVORITES }];
  if (SessionStore.user && SessionStore.user.showCredit) {
    items.push({ name: 'Mis créditos', routeName: routeNaming.MY_CREDITS });
  }
  return items;
};

const logout = () => (
  SessionStore.logout()
);

const MyAccountMenu = ({ indexSelectedItem }) => {
  if (!SessionStore.loggedIn) {
    return (
      <AppRedirect routeName={routeNaming.HOME} />
    );
  }

  return (
    <div className={styles.menuContainer}>
      <div className={styles.menu}>
        {menuItems().map((item, index) => {
          const isSelected = indexSelectedItem === index;
          return (
            <AppLink
              className={isSelected ? styles.menuItemSelected : styles.menuItem}
              routeName={item.routeName}
              key={item.name}
            >
              {item.name}
            </AppLink>
          );
        })}
        <button className={[styles.menuItem, styles.menuItemButton].join(' ')} onClick={logout}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
};

MyAccountMenu.propTypes = IPropTypes;
MyAccountMenu.defaultProps = defaultProps;

const ObservedMyAccountMenu = observer(MyAccountMenu);

export { ObservedMyAccountMenu as MyAccountMenu };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-account-menu/MyAccountMenu.jsx